<template>
  <v-chart class="chart" :option="options" autoresize/>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import {
  TooltipComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

use([
  CanvasRenderer,
  PieChart,
  TooltipComponent
])

export default {
  components: {
    VChart
  },
  props: {
    options: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/PieChart.vue